import * as React from 'react';
import S from './RichText.styles';
const RichText = ({ id, content, gapFlush = 'both', image, title, titleSize = 'small', titleTheme = 'gradient', width = 'full', ...otherProps }) => {
    const widgetContent = image
        ? `<img src=${image?.src} alt=${image?.altText} /> ${content}`
        : content;
    return (React.createElement(S.Container, { id: id, flush: content ? gapFlush : 'none', ...otherProps },
        title && (React.createElement(S.Title, { "data-title-theme": titleTheme, "data-title-size": titleSize }, title)),
        React.createElement(S.Content, { "data-width": width, "data-image": image ? 'true' : 'false', dangerouslySetInnerHTML: { __html: widgetContent } })));
};
export default RichText;
